import { differenceInMinutes } from 'date-fns';

import { getLocalizedDateTime } from 'pages/cart/details/common';
import {
  getFormattedShortDateFromIsoString,
  getFormattedTimeFromIsoStringWithTimezone,
} from 'pages/cart/details/utils';

export const postOrderTimeout = (currentOrderTime: string, timeoutInMinutes: number): boolean =>
  Math.abs(differenceInMinutes(new Date(currentOrderTime), new Date())) < timeoutInMinutes;

export const deliveryCompleteTimeout = (
  currentOrderTime: string,
  timeoutInMinutes: number
): boolean =>
  Math.abs(differenceInMinutes(new Date(currentOrderTime), new Date())) > timeoutInMinutes;

export const getFormattedCateringPickupDateTime = ({
  dateString,
  timezone,
  formatMessage,
}: {
  dateString: string;
  timezone?: string | null;
  formatMessage: Function;
}): string => {
  const formattedDate = getFormattedShortDateFromIsoString(dateString, formatMessage);
  const formattedTime = getFormattedTimeFromIsoStringWithTimezone(
    dateString,
    timezone,
    formatMessage
  );
  const localizedPickupDateTime = getLocalizedDateTime(
    { date: formattedDate, time: formattedTime },
    formatMessage
  );

  return localizedPickupDateTime;
};
